import { CdkDragDrop, CdkDragStart, CdkDragEnd } from '@angular/cdk/drag-drop';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChildren,
  QueryList
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Stop, SectorCompress } from '../../../../@core/models/live-route';
import { DriverDialogComponent } from '../../../../@theme/components/driver-dialog/driver-dialog.component';
import { DashboardBase } from '../dashboard.base';
import { LocationModel } from '../../../../@core/models/location';
import { RouteStatus } from '../../../../@core/models/dto-routestatus';
import { LiveRouteType } from '../../../../@core/models/live-route-type';
import { MatDialogConfig } from '@angular/material';
import { PudoDealerMapDialogComponent } from '../../../../@theme/components/pudo-dealer-map-dialog/pudo-dealer-map-dialog.component';
import { GeoTabUser } from '../../../../@core/models/geoab-user';

@Component({
  selector: 'ngx-mapinforoutes',
  templateUrl: './map-info-routes.component.html',
  styleUrls: ['./map-info-routes.component.scss']
})
export class MapInfoRoutesComponent extends DashboardBase implements OnInit, OnDestroy
{
  sub: Subscription;
  @Input()
  tpl: TemplateRef<any>;
  @ViewChildren('matCheckbox') private matCheckboxes: QueryList<any>;
  geotabUsers = Array<GeoTabUser>();

  ngOnInit() {
    if (
      this._sectorService.SectorID > 0 &&
      this._sectorService.RouteDate != null
    ) {
      this._onholdService.initialiseOnholdRoute();
    }
  }

  get liverouteType() {
    return LiveRouteType;
  }

  public displayedOnHoldColumns: string[] = [
    'IsSelected',
    'StatusIcon',
    'ExpDate',
    'Address.Postal_Code',
    'TotalParcel',
    'CustomerName',
    'Address.Address1'
  ];

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this._onholdService.currentStopsValue != null)
      return (
        this._onholdService.selectedStops.length ==
        this._onholdService.currentStopsValue.StopCount
      );
    else return false;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle($event) {
    let i = 0;
    const matCheckboxes = this.matCheckboxes.toArray();
    for (const stop of this._onholdService.currentStopsValue.StopsList) {
      stop.IsSelected = $event.checked;
      matCheckboxes[i].checked = $event.checked;
      i++;
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Stop): string {
    return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
  }

  public onClickUpdateRoute(Route_ID: number) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '500px';
    dialogConfig.width = '300px';
    this._routeService.initialiseRoute(Route_ID); /*
    dialogConfig.data = {
      RouteID: Route_ID
    };*/

    const dialogRef = this.dialog.open(DriverDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.updateDriverName(Route_ID, data);
      }
    });
  }

  showIcon(routeId: number) {
    const el = <HTMLElement>document.querySelector(`#route${routeId}`);
    el.style.visibility = 'visible';
  }

  hideIcon(routeId: number) {
    const el = <HTMLElement>document.querySelector(`#route${routeId}`);
    el.style.visibility = 'hidden';
  }

  updateDriverName(Route_ID: number, name: string) {
    for (const route of this._sectorService.currentSectorValue.RouteCompress) {
      if (route.Route_ID === Route_ID) {
        route.Route_Driver_Name = name;
      }
    }
  }

  updateCheckbox(event: any, Consol_ID: number) {
    this._onholdService.GetStop(Consol_ID).IsSelected = event.checked;
  }

  public onDragStart(event: CdkDragStart<string[]>) {
    this.draggingList = true;
  }

  public onDragEnded(event: CdkDragEnd<string[]>) {
    this.draggingList = false;
  }

  public onClickPudoDealerSelection(routeID: number) {
    this._dropOffPoint.RouteID = routeID;
    const dialogRef = this.dialog.open(PudoDealerMapDialogComponent, {
      height: '800px',
      width: '600px'
    });
  }

  // On met le stop en attente
  dropOnHold(event: CdkDragDrop<Stop[]>) {
    if (this._stopService.selectedStops.length > 1) {
    } else {
      const prevIndex = this._stopService.dataSource.data.findIndex(
        (d) => d === event.item.data
      );
      const stopToMove = event.previousContainer.data[prevIndex];
      this._stopService.GetStop(stopToMove.Consol_ID).IsSelected = true;
    }
    const InsertAt = event.currentIndex;
    this.BatchmoveToOnHold(this._stopService.selectedStops, InsertAt + 1);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  changeLiveRouteStatus(event: any, routeId: number) {
    const selectedStatus = event.value;
    this.apiProvider
      .UpdateLiveRouteStatus(
        routeId,
        this.authenticationService.currentUserValue.UserID,
        this._stopService.RouteDate,
        selectedStatus
      )
      .subscribe((result) => {
        this.toastrService.success(
          this.translate.instant('Status'),
          this.translate.instant('Changement effectué'),
          {
            positionClass: 'toast-bottom-left',
            disableTimeOut: false,
            enableHtml: true
          }
        );
      });
  }

  getStatus(routeStatus: RouteStatus, stop: Stop): string {
    let _routeStatus = routeStatus.RouteStatus;
    const _minRouteStatus = stop.Min_Live_Route_Status;
    const _maxRouteStatus = stop.Max_Live_Route_Status;
    const Sectors: SectorCompress = this._sectorService.currentSectorValue;
    let _stopStatus: string = '000';
    let _cssclass: string = 'received';

    if (Sectors) {
      for (let Oneroute of Sectors.RouteCompress) {
        if (Oneroute.Route_ID === stop.Route_ID) {
          _routeStatus = String(Oneroute.LiveRouteStatus);
          break;
        }
      }
    }

    _stopStatus = '0' + String(_minRouteStatus) + String(_maxRouteStatus);

    switch (_stopStatus) {
      case '000': {
        _cssclass = 'received';
        break;
      }
      case '001': {
        _cssclass = 'received';
        break;
      }
      case '011': {
        _cssclass = 'received';
        break;
      }
      case '111': {
        _cssclass = 'received';
        break;
      }
      case '022': {
        _cssclass = 'inroute';
        break;
      }
      case '033': {
        _cssclass = 'failed';
        break;
      }
      case '044': {
        _cssclass = 'shipped';
        break;
      }
      case '444': {
        _cssclass = 'shipped';
        break;
      }
      case '422': {
        _cssclass = 'inroute';
        break;
      }
      default: {
        _cssclass = 'received';
        break;
      }
    }

    return _cssclass;
  }
}
